import { render } from "./RealisationItem.vue?vue&type=template&id=689d810e&scoped=true"
import script from "./RealisationItem.vue?vue&type=script&lang=js"
export * from "./RealisationItem.vue?vue&type=script&lang=js"

import "./RealisationItem.vue?vue&type=style&index=0&id=689d810e&scoped=true&lang=css"

import exportComponent from "/builds/tapetum1/tapetum-landing/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-689d810e"]])

export default __exports__